import { createIconComponent } from '../../factory/create-icon-component';
export const AustraliaIcon = createIconComponent(
  'AustraliaIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10083_32575)">
      <path d="M23 5.00006H1V19.9999H23V5.00006Z" fill="#0052B4" />
      <path
        d="M10.5995 12.4997C10.6115 12.4864 10.6234 12.473 10.6352 12.4595C10.6234 12.473 10.6113 12.4863 10.5992 12.4997H10.5995Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.1306 14.3422L9.60145 15.3491L10.6648 15.0978L10.1886 16.1021L11.0437 16.7956L9.97906 17.041L9.98203 18.1571L9.1306 17.4589L8.27922 18.1571L8.28218 17.041L7.21759 16.7956L8.07267 16.1021L7.59645 15.0978L8.65975 15.3491L9.1306 14.3422Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.6318 15.593L17.8564 16.0733L18.3636 15.9534L18.1365 16.4324L18.5443 16.7632L18.0365 16.8802L18.0379 17.4126L17.6318 17.0796L17.2258 17.4126L17.2272 16.8802L16.7194 16.7632L17.1272 16.4324L16.9001 15.9534L17.4073 16.0733L17.6318 15.593Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.5436 10.4982L15.7682 10.9785L16.2754 10.8586L16.0482 11.3376L16.456 11.6684L15.9483 11.7854L15.9497 12.3178L15.5436 11.9847L15.1375 12.3178L15.1389 11.7854L14.6311 11.6684L15.0389 11.3376L14.8119 10.8586L15.319 10.9785L15.5436 10.4982Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.6318 7.58679L17.8564 8.06711L18.3636 7.94714L18.1365 8.42622L18.5443 8.75699L18.0365 8.87406L18.0379 9.4064L17.6318 9.0733L17.2258 9.4064L17.2272 8.87406L16.7194 8.75699L17.1272 8.42622L16.9001 7.94714L17.4073 8.06711L17.6318 7.58679Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.4566 9.77039L19.6812 10.2507L20.1883 10.1308L19.9613 10.6098L20.3691 10.9405L19.8613 11.0576L19.8627 11.5899L19.4566 11.2569L19.0505 11.5899L19.0519 11.0576L18.5441 10.9405L18.952 10.6098L18.7248 10.1308L19.232 10.2507L19.4566 9.77039Z"
        fill="#F0F0F0"
      />
      <path
        d="M18.1524 12.3178L18.329 12.8738H18.9006L18.4382 13.2174L18.6149 13.7734L18.1524 13.4298L17.6898 13.7734L17.8665 13.2174L17.404 12.8738H17.9757L18.1524 12.3178Z"
        fill="#F0F0F0"
      />
      <path
        d="M12 5.00006V6.3427L10.0592 7.44566H12V10.0542H9.46042L12 11.4971V12.4998H10.8536L7.69565 10.7057V12.4998H5.30435V10.3652L1.54759 12.4998H1V11.1571L2.94077 10.0542H1V7.44566H3.53958L1 6.00226V5.00006H2.14641L5.30435 6.79418V5.00006H7.69565V7.13457L11.4524 5.00006H12Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.1875 4.99988H5.8125V8.04663H1V9.45286H5.8125V12.4997H7.1875V9.45286H12V8.04663H7.1875V4.99988Z"
        fill="#D80027"
      />
      <path
        d="M7.69595 10.0542L12.0003 12.4998V11.8082L8.91313 10.0542H7.69595Z"
        fill="#0052B4"
      />
      <path
        d="M7.69595 10.0542L12.0003 12.4998V11.8082L8.91313 10.0542H7.69595Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.69595 10.0542L12.0003 12.4998V11.8082L8.91313 10.0542H7.69595Z"
        fill="#D80027"
      />
      <path
        d="M4.08713 10.0542L1 11.8082V12.4998L5.30435 10.0542H4.08713Z"
        fill="#D80027"
      />
      <path
        d="M5.30435 7.44547L1 4.99988V5.69143L4.08718 7.44547H5.30435Z"
        fill="#0052B4"
      />
      <path
        d="M5.30435 7.44547L1 4.99988V5.69143L4.08718 7.44547H5.30435Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.30435 7.44547L1 4.99988V5.69143L4.08718 7.44547H5.30435Z"
        fill="#D80027"
      />
      <path
        d="M8.91317 7.44547L12.0003 5.69143V4.99988L7.69595 7.44547H8.91317Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_10083_32575">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
